import { MainLayout } from "@/novus/layouts/MainLayout"
import React from "react"

const ErrorScreen = ({ message }: { message?: string }) => {
  return (
    <MainLayout showLogo={true}>
      <div className="text-red-500">{message || "An error has occurred"}</div>
    </MainLayout>
  )
}

export default ErrorScreen
